// ----------------------------------------------------------------------

export const role = [
  'Super Admin',
  'Admin',
  'Manager',
  'Client',
  'Staff',
  'Super Admin',
  'Admin',
  'Manager',
  'Client',
  'Staff',
  'Super Admin',
  'Admin',
  'Manager',
  'Client',
  'Staff',
  'Super Admin',
  'Admin',
  'Manager',
  'Client',
  'Staff',
  'Super Admin',
  'Admin',
  'Manager',
  'Client',
  'Staff',
  'Super Admin',
  'Admin',
  'Manager',
  'Client',
  'Staff',
  'Super Admin',
  'Admin',
  'Manager',
  'Client',
  'Staff',
  'Super Admin',
  'Admin',
  'Manager',
  'Client',
  'Staff',
];
